import { lazy, Suspense } from 'react'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/dashboard')({
  component: RouteComponent,
  beforeLoad: ({ context: { user } }) => {
    if (!user) throw redirect({ to: '/sign-in' })
    return { breadcrumb: 'Dashboard' }
  },
  loader: async ({ context: { orpc, queryClient } }) => {
    await queryClient.ensureQueryData(
      orpc.backoffice.villages.getAll.queryOptions()
    )
  }
})

const AdminView = lazy(() =>
  import('@/components/dashboard/admin-view').then((mod) => ({
    default: mod.AdminView
  }))
)

const AdminViewPending = lazy(() =>
  import('@/components/dashboard/admin-view').then((mod) => ({
    default: mod.AdminPendingView
  }))
)

const VillageView = lazy(() =>
  import('@/components/dashboard/village-view').then((mod) => ({
    default: mod.VillageView
  }))
)

function RouteComponent() {
  const { user, orpc } = Route.useRouteContext()

  if (user?.isAdmin) {
    return (
      <Suspense fallback={<AdminViewPending />}>
        <AdminViewAsync />
      </Suspense>
    )
  }

  return <VillageView user={user} orpc={orpc} />
}

function AdminViewAsync() {
  const { user, orpc } = Route.useRouteContext()

  return <AdminView user={user} orpc={orpc} />
}
